import type { RunbookSummary } from '../devices/contracts';

// Positive protocol support, independent of release version. A larger or unknown version alone
// proves neither support for typed text nor that a read-only script is pinned in the endpoint build.
export const TEXT_PARAMETERS_FEATURE = 'runbook-text-parameters-v1';
export const READ_HASHES_FEATURE = 'runbook-read-hashes-v3';
export const RUNBOOK_UPDATE_CODE = 'runbook_agent_update_required';
export const RUNBOOK_UPDATE_REQUIRED = 'Agent update required: install the matching signed agent and wait for its updated inventory before running this runbook.';

export function runbookUnavailableReason(runbook: Pick<RunbookSummary, 'requiredAgentFeatures'> & { parameters: Array<{ type: 'integer' | 'string' }> }, agent?: { features?: unknown } | null): string | null {
  const required = [...(runbook.requiredAgentFeatures ?? []),
    ...(runbook.parameters.some(p => p.type === 'string') ? [TEXT_PARAMETERS_FEATURE] : [])];
  const features = Array.isArray(agent?.features) ? agent.features : [];
  return required.some(feature => !features.includes(feature)) ? RUNBOOK_UPDATE_REQUIRED : null;
}
